import {getRouteApi} from "@tanstack/react-router";

export const leadContactsRouteApi = getRouteApi("/_app/sales/leads/$leadId/contacts/");
